import React, { useState, useEffect } from "react";
import "./EmployeeRegistrationPage.css";

const EmployeeRegistrationPage = () => {
  const [requiredFields, setRequiredFields] = useState(null); // Initialize as null
  const [formData, setFormData] = useState({
    user_photo: null,
    user_name: "",
    user_surname: "",
    user_nickname: "",
    user_mobile: "",
    user_emergency_contact: "",
    date_of_birth: "",
    user_gender: "",
    emp_department: "",
    emp_position: "",
    training_materials: false,
    user_consent_checkbox: false,
  });
  const [consentPolicyUrl, setConsentPolicyUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchRequiredFields();
  }, []);

  const fetchRequiredFields = async () => {
    try {
      const response = await fetch(
        "https://t9t3cfvgj1.execute-api.eu-west-1.amazonaws.com/dev/setup-configuration",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "get_required_fields",
            place_id: "test77a7a7",
          }),
        }
      );

      const data = await response.json();
      if (response.status === 200) {
        // Parse the body field as JSON
        const body = JSON.parse(data.body);
        setRequiredFields(body.required_fields); // Set requiredFields
        setConsentPolicyUrl(body.consent_policy);
      } else {
        setError("Не удалось загрузить конфигурацию формы.");
      }
    } catch (error) {
      setError("Ошибка при загрузке данных.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      user_photo: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("place_id", "test77a7a7");
      formDataToSend.append("user_name", formData.user_name);
      formDataToSend.append("user_surname", formData.user_surname);
      formDataToSend.append("user_nickname", formData.user_nickname);
      formDataToSend.append("user_mobile", formData.user_mobile);
      formDataToSend.append(
        "user_emergency_contact",
        formData.user_emergency_contact
      );
      formDataToSend.append("date_of_birth", formData.date_of_birth);
      formDataToSend.append("user_gender", formData.user_gender);
      formDataToSend.append("emp_department", formData.emp_department);
      formDataToSend.append("emp_position", formData.emp_position);
      formDataToSend.append("training_materials", formData.training_materials);
      formDataToSend.append(
        "user_consent_checkbox",
        formData.user_consent_checkbox
      );
      if (formData.user_photo) {
        formDataToSend.append("user_photo", formData.user_photo);
      }

      const response = await fetch(
        "https://ste1h7g7s7.execute-api.eu-west-1.amazonaws.com/LoyaltySystem1/UserRecords",
        {
          method: "POST",
          body: formDataToSend,
        }
      );

      const data = await response.json();
      if (response.status === 200) {
        alert("Данные успешно отправлены!");
      } else {
        alert("Ошибка при отправке данных.");
      }
    } catch (error) {
      alert("Ошибка при отправке данных.");
    }
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (!requiredFields) {
    return <div className="error">Конфигурация формы не загружена.</div>;
  }

  return (
    <div className="employee-registration-page">
      <h1>Регистрация сотрудника</h1>
      <p>
        Приветственное сообщение от HR менеджера, состоящее из некоторого
        количества максимум символов
      </p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Загрузите фотографию</label>
          <input
            type="file"
            name="user_photo"
            onChange={handleFileChange}
            accept="image/*"
            required
          />
        </div>
        {requiredFields.user_name && (
          <div className="form-group">
            <label>Имя</label>
            <input
              type="text"
              name="user_name"
              value={formData.user_name}
              onChange={handleInputChange}
              required
            />
          </div>
        )}
        {requiredFields.user_surname && (
          <div className="form-group">
            <label>Фамилия</label>
            <input
              type="text"
              name="user_surname"
              value={formData.user_surname}
              onChange={handleInputChange}
              required
            />
          </div>
        )}
        {requiredFields.user_nickname && (
          <div className="form-group">
            <label>Никнейм</label>
            <input
              type="text"
              name="user_nickname"
              value={formData.user_nickname}
              onChange={handleInputChange}
            />
          </div>
        )}
        {requiredFields.user_mobile && (
          <div className="form-group">
            <label>Телефон</label>
            <input
              type="tel"
              name="user_mobile"
              value={formData.user_mobile}
              onChange={handleInputChange}
              required
            />
          </div>
        )}
        {requiredFields.user_emergency_contact && (
          <div className="form-group">
            <label>Телефон для экстренных случаев</label>
            <input
              type="tel"
              name="user_emergency_contact"
              value={formData.user_emergency_contact}
              onChange={handleInputChange}
              required
            />
          </div>
        )}
        {requiredFields.date_of_birth && (
          <div className="form-group">
            <label>Дата рождения</label>
            <input
              type="date"
              name="date_of_birth"
              value={formData.date_of_birth}
              onChange={handleInputChange}
              required
            />
          </div>
        )}
        {requiredFields.user_gender && (
          <div className="form-group">
            <label>Пол</label>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="user_gender"
                  value="Male"
                  checked={formData.user_gender === "Male"}
                  onChange={handleInputChange}
                  required
                />
                Мужской
              </label>
              <label>
                <input
                  type="radio"
                  name="user_gender"
                  value="Female"
                  checked={formData.user_gender === "Female"}
                  onChange={handleInputChange}
                  required
                />
                Женский
              </label>
            </div>
          </div>
        )}
        <div className="form-group">
          <label>Департамент</label>
          <select
            name="emp_department"
            value={formData.emp_department}
            onChange={handleInputChange}
            required
          >
            <option value="">Выбрать</option>
            <option value="Работники кухни">Работники кухни</option>
            <option value="Обслуживающий персонал">
              Обслуживающий персонал
            </option>
            <option value="Административный персонал">
              Административный персонал
            </option>
            <option value="Кальянный сервис">Кальянный сервис</option>
          </select>
        </div>
        <div className="form-group">
          <label>Должность</label>
          <select
            name="emp_position"
            value={formData.emp_position}
            onChange={handleInputChange}
            required
          >
            <option value="">Выбрать</option>
            <option value="Шеф-повар">Шеф-повар</option>
            <option value="Официант">Официант</option>
            <option value="Управляющий">Управляющий</option>
            <option value="Кальянный мастер">Кальянный мастер</option>
          </select>
        </div>
        <div className="form-group">
          <label>
            <input
              type="checkbox"
              name="training_materials"
              checked={formData.training_materials}
              onChange={handleInputChange}
            />
            Скачать тренировочные материалы
          </label>
        </div>
        {requiredFields.user_consent_checkbox && (
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                name="user_consent_checkbox"
                checked={formData.user_consent_checkbox}
                onChange={handleInputChange}
                required
              />
              Согласие на обработку данных (
              <a
                href={consentPolicyUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Политика конфиденциальности
              </a>
              )
            </label>
          </div>
        )}
        <button type="submit" className="submit-button">
          Отправить
        </button>
      </form>
    </div>
  );
};

export default EmployeeRegistrationPage;
